import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom"
import NotFound404 from './pages/notFound404';
import Navbar from './components/navbar';
import Login from './pages/login';
import Axios from 'axios'
import { connect } from 'react-redux';
import { setUser } from './actions/userActions'
import ProtectedRoute from './components/routes/protectedRoute'
import UserOptionalRoute from './components/routes/userOptionalRoute'

import PublicRoute from './components/routes/publicRoute'
import CreateAccount from './pages/createAccount'
import PaymentSuccess from './pages/paymentSuccess'
import PaymentCancelled from './pages/paymentCancelled'
import Account from './pages/account'
import AdminRoute from './components/routes/adminRoute'
import Admin from './pages/admin'
import Footer from './components/footer';
import Help from './pages/help'
import ForgotPassword from './pages/forgotPassword'
import ResetPassword from './pages/resetPassword'
import Print from './pages/print'
import AdminStats from './pages/adminStats'
import AdminPrinters from './pages/adminPrinters'
import AdminActions from './pages/adminActions'
import AdminShipping from './pages/adminShipping'
import AdminOrders from './pages/adminOrders'
import LoginOrQuote from './pages/loginOrQuote';
import AdminFilaments from './pages/adminFilaments'

import Orders from './pages/orders'

import "./styles.css"
import { faPlusSquare } from '@fortawesome/free-solid-svg-icons';

class App extends Component {
  state = {
    showPopup: false,
    ready: false
  }
  componentDidMount() {
    Axios.defaults.headers.common['x-auth-token'] = localStorage.jwtToken
    Axios.get('/api/user/user').then(res => {
      if (res.data.success) {
        this.props.setUser({ user: res.data.user, token: localStorage.jwtToken })
        this.setState({ ready: true })

      } else {
        this.setState({ showPopup: true })
        Axios.get("/api/user/generate/guest/id").then(res => {
          this.props.setUser({ user: res.data.user, token: res.data.token })
          this.setState({ ready: true })
        })
      }
    })
  }
  closePopup = () => {
    this.setState({ showPopup: false })
  }
  render() {
    let darkmode = this.props.user ? this.props.user.darkmode : true
    if (!this.state.ready) {
      return <div></div>
    }
    return (
      <div style={{

        background: "rgb(59, 74, 88)", minHeight: "100vh"
      }}>
        <Router >
          <Navbar />
          <Footer />
          <div style={{ paddingTop: '94px', paddingBottom: "130px" }}>
            <Switch>
          //pages accessible for non logged in users#
              <PublicRoute exact={true} path="/"><Redirect to='/print' /></PublicRoute>
              <PublicRoute path="/login"><Login /></PublicRoute>
              <PublicRoute path="/create-account"><CreateAccount /></PublicRoute>
              <PublicRoute path="/forgot-password"><ForgotPassword /></PublicRoute>
              <PublicRoute path="/reset-password"><ResetPassword /></PublicRoute>
              <UserOptionalRoute path="/print"><Print /></UserOptionalRoute>
              <Route path="/help"><Help /></Route>
              <ProtectedRoute path="/account"> <Account /> </ProtectedRoute>
              <ProtectedRoute path="/orders"> <Orders /> </ProtectedRoute>

              <AdminRoute exact={true} path='/admin'><Admin /></AdminRoute>
              <AdminRoute path='/admin/stats'><AdminStats /></AdminRoute>
              <AdminRoute path='/admin/printers'><AdminPrinters /></AdminRoute>
              <AdminRoute path='/admin/shipping'><AdminShipping /></AdminRoute>
              <AdminRoute path='/admin/orders'><AdminOrders /></AdminRoute>
              <AdminRoute path='/admin/actions'><AdminActions /></AdminRoute>
              <AdminRoute path='/admin/filaments'><AdminFilaments /></AdminRoute>

              <Route><NotFound404 /></Route>
            </Switch></div>
          {this.state.showPopup &&
            <LoginOrQuote darkmode={darkmode} close={() => this.closePopup()} />
          }
        </Router>

      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user
  }
}
function mapDispatchToProps(dispatch) {
  return {
    setUser: (data) => { dispatch(setUser(data)) }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);